import { useCallback, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Formik } from "formik";
import {
  AppCard,
  AppDatePicker,
  AppNoInfo,
  AppNotificationAlert,
  AppRemixIcon,
} from "@/layout/AppComponents";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import ReactDOMServer from "react-dom/server";
import { axiosPath } from "../../../../routing/helpers/router";
import AppLink from "../../../../routing/helpers/AppLink";
import { copyToClibpoard } from "../../../../minions/string";
import BreadcrumbHandler from "../../../../layout/components/breadcrumb/BreadcrumbHandler";
import colors from "../../../../constants/colors";
import Translator from "../../../../layout/components/helpers/Translator";
import _ from "lodash";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";
import { useDispatch } from "react-redux";
import * as currentPageAction from "../../../../store/actions/currentPageAction";

export default function CommunicationPipelineInquiryListScreen() {
  const { moduleBridgeHex } = useParams();
  const formRef = useRef(null);
  const moduleData = useSelector((state) => state.currentPage?.moduleData);
  const [userType] = useState("admin");
  const locale = useSelector((state) => state.global.urlData.lang);
  const [inquiries, setInquiries] = useState();
  const [unseenCommunicationInquiries, setUnseenCommunicationInquiries] =
    useState([]);
  const [filterValues, setFilterValues] = useState({
    from: "",
    to: "",
  });
  const dispatch = useDispatch();


  const loadInquiries = useCallback(async () => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_admin_inquiry_list"),
        {
          moduleBridgeHex,
          type: userType,
          filters: filterValues,
        },
      )
      .then((r) => {
        setInquiries(r.data?.inquiries);
        setUnseenCommunicationInquiries(r?.data?.unseenCommunicationInquiries);
      })
      .catch(() => {});
  }, [moduleBridgeHex, filterValues, userType]);

  useEffect(() => {
    loadInquiries();
  }, [filterValues]);

  const handleCopyClipboard = useCallback((inquiryHex) => {
    copyToClibpoard(inquiryHex);
    AppNotificationAlert({
      title: ReactDOMServer.renderToString(
        <Translator file="module-communicationPipeline" name="copied" />,
      ),
      message: ReactDOMServer.renderToString(
        <Translator
          file="module-communicationPipeline"
          name="query-code-copied-clipboard"
        />,
      ),
      type: "success",
      duration: 5000,
      position: "top-right",
    });
  }, []);

    // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <BreadcrumbHandler
        paths={
          moduleBridgeHex
            ? [
                {
                  name: `${moduleData?.moduleName}`,
                },
                {
                  name: ReactDOMServer.renderToString(
                    <Translator
                      file="module-communicationPipeline"
                      name="consult"
                    />,
                  ),
                },
              ]
            : [{ name: "..." }]
        }
      />
      <Container>
        <AppCard className="mb-2">
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={filterValues}
            onSubmit={(payload) => setFilterValues(payload)}
          >
            {({
              setFieldValue,
              handleSubmit,
              values,
              errors,
              resetForm,
              initialValues,
            }) => (
              <form onSubmit={handleSubmit} ref={formRef}>
                <div className="row">
                  <div className="col-lg-6">
                    <AppDatePicker
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="from"
                        />,
                      )}
                      placeholder={ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="select-date"
                        />,
                      )}
                      locale={locale}
                      value={values.from}
                      onChange={(opt) => setFieldValue("from", opt)}
                      showMonthDropdown
                      showYearDropdown
                      error={errors.from}
                      isClearable
                    />
                  </div>
                  <div className="col-lg-6">
                    <AppDatePicker
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="to"
                        />,
                      )}
                      placeholder={ReactDOMServer.renderToString(
                        <Translator
                          file="module-communicationPipeline"
                          name="select-date"
                        />,
                      )}
                      locale={locale}
                      value={values.to}
                      onChange={(opt) => setFieldValue("to", opt)}
                      showMonthDropdown
                      showYearDropdown
                      error={errors.to}
                      isClearable
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-info btn-sm float-right"
                    >
                      Filtrar
                    </button>
                    {!_.isEqual(values, initialValues) && (
                      <button
                        type="submit"
                        className="btn btn-outline-danger btn-sm float-right mr-2"
                        onClick={() => resetForm()}
                      >
                        <Translator
                          file="module-communicationPipeline"
                          name="clear-filters"
                        />
                      </button>
                    )}
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </AppCard>
        {inquiries &&
          inquiries.map((i) => (
            <LazyLoad key={i.hex}>
              <AppCard className="mb-2">
                <div className="d-flex align-center">
                  <AppRemixIcon
                    icon="file-copy"
                    className="pointer"
                    onClick={() => handleCopyClipboard(i.hex)}
                  />
                  <AppLink
                    path="user_module_communicationPipeline_admin_inquiry_communication"
                    params={{
                      moduleBridgeHex,
                      inquiryHex: i.hex,
                    }}
                    className="wl-title-md wl-title-color"
                  >
                    <span className="badge badge-info mx-2">{i?.hex}</span>
                    <span className="badge badge-dark mr-2">
                      {i?.dateStamp}
                    </span>
                    <span>{i?.name}</span>
                    {unseenCommunicationInquiries?.includes(i?.hex) && (
                      <span
                        className="ml-2"
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-communicationPipeline"
                            name="contains-unread-messages"
                          />,
                        )}
                      >
                        <AppRemixIcon
                          icon="notification"
                          color={colors.bootstrapWarning}
                          filled
                        />
                      </span>
                    )}
                  </AppLink>
                </div>
              </AppCard>
            </LazyLoad>
          ))}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;
  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .minHeight600 {
    min-height: 600px;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
